import { render, staticRenderFns } from "./backlog.vue?vue&type=template&id=9d4f8476&scoped=true"
import script from "./backlog.vue?vue&type=script&lang=js"
export * from "./backlog.vue?vue&type=script&lang=js"
import style0 from "./backlog.vue?vue&type=style&index=0&id=9d4f8476&prod&lang=css"
import style1 from "./backlog.vue?vue&type=style&index=1&id=9d4f8476&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4f8476",
  null
  
)

export default component.exports